import { IEntityWithStatus, EntityWithStatus } from "./EntityWithStatus";
import { IEntity } from "./Entity";
import { App03Frameworks, IApp03Workflow } from "./App03Workflow";
import { IApp03PortfolioUser } from "./App03PortfolioUser";
import { IEntityCustomFields } from "./EntityCustomFields";


export interface IApp03Portfolio extends IEntityWithStatus, IEntityCustomFields {
    PortfolioTypeID?: number;
    LeadUserID?: number;
    FrameworkID?: number;
    CustomerID?: number;
    App03Workflows?: IApp03Workflow[];
    App03PortfolioUsers?: IApp03PortfolioUser[];
}

export class App03Portfolio extends EntityWithStatus implements IApp03Portfolio {
    public CustomerID = null;
    public PortfolioTypeID = null;
    public LeadUserID = null;
    public FrameworkID = null;
    public CustomFields = [];

    constructor(portfolioTypeID: number, frameworkID: App03Frameworks) {
        super();
        this.PortfolioTypeID = portfolioTypeID;        
        this.FrameworkID = frameworkID;
    }
}

export enum PortfolioTypes {
    General = 1,
    Project = 2
}